module.exports = __webpack_public_path__ + "static/media/icon-order-cancel-gray.22eacea6.svg";